var _excluded = ["children", "className", "onChangeDropdownVisibility", "placement", "offset"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useEffect, useRef } from "react";
import { node, func, string, arrayOf, number, oneOf } from "prop-types";
import useOnClickOutside from "use-onclickoutside";
import classNamesMaker from "classnames";
import { usePopper } from "react-popper";
import { getAuthorizedRestProps } from "#library/utils/propsUtil";
import { hideDropdownMenu, setDropdownMenuPosition } from "./Dropdown.actions";
import { useDropdown } from "#library/components/Dropdown/components/Provider";
import { Item } from "#library/components/Dropdown/components/Item";
import { Menu } from "#library/components/Dropdown/components/Menu";
import { TriggerButton } from "#library/components/Dropdown/components/TriggerButton";
import { TriggerMenuItem } from "#library/components/Dropdown/components/TriggerMenuItem";
import styles from "./styles/dropdown.module.css";
export var DROPDOWN_MENU_PLACEMENTS = {
  AUTO: "auto",
  AUTO_START: "auto-start",
  AUTO_END: "auto-end",
  TOP: "top",
  TOP_START: "top-start",
  TOP_END: "top-end",
  BOTTOM: "bottom",
  BOTTOM_START: "bottom-start",
  BOTTOM_END: "bottom-end",
  RIGHT: "right",
  RIGHT_START: "right-start",
  RIGHT_END: "right-end",
  LEFT: "left",
  LEFT_START: "left-start",
  LEFT_END: "left-end"
};
export var Dropdown = function Dropdown(_ref) {
  var children = _ref.children,
    className = _ref.className,
    onChangeDropdownVisibility = _ref.onChangeDropdownVisibility,
    placement = _ref.placement,
    offset = _ref.offset,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _useDropdown = useDropdown(),
    state = _useDropdown.state,
    dispatch = _useDropdown.dispatch;
  var dropdownRef = useRef();
  var dropdownClassNames = classNamesMaker(styles["jds-Dropdown__container"], className);
  useEffect(function () {
    onChangeDropdownVisibility(state.isDropdownMenuVisible);
  }, [onChangeDropdownVisibility, state.isDropdownMenuVisible]);
  var _usePopper = usePopper(state.triggerButton, state.dropdownMenu, {
      placement: placement,
      modifiers: [{
        name: "offset",
        options: {
          offset: offset
        }
      }, {
        name: "flip"
      }]
    }),
    test = _usePopper.styles;
  useEffect(function () {
    if (test.popper) {
      dispatch(setDropdownMenuPosition(test.popper));
    }
  }, [dispatch, test.popper]);
  useOnClickOutside(dropdownRef, function () {
    return dispatch(hideDropdownMenu());
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, getAuthorizedRestProps(restProps), {
    ref: dropdownRef,
    className: dropdownClassNames
  }), children);
};
Dropdown.propTypes = {
  children: node.isRequired,
  className: string,
  onChangeDropdownVisibility: func,
  placement: oneOf(Object.values(DROPDOWN_MENU_PLACEMENTS)),
  // see https://popper.js.org/docs/v2/constructors/#options
  offset: arrayOf(number) // see https://popper.js.org/docs/v2/modifiers/offset/
};

export var defaultProps = {
  className: null,
  onChangeDropdownVisibility: function onChangeDropdownVisibility() {
    return null;
  },
  placement: DROPDOWN_MENU_PLACEMENTS.BOTTOM_START,
  offset: [0, 8] // dropdown has a 8px "margin" from trigger
};

Dropdown.defaultProps = defaultProps;

// If edited, update them to index.js too.
Dropdown.Item = Item;
Dropdown.Menu = Menu;
Dropdown.TriggerButton = TriggerButton;
Dropdown.TriggerMenuItem = TriggerMenuItem;